import React, { Component } from 'react';
import Map from '../../js/map';

export default class Location extends Component {
  constructor(props) {
    super(props);
    const defaultLocation = this.props.defaultLocation.length === 0 ? [116.407041, 39.907123] : this.props.defaultLocation;
    this.state = {
      location: defaultLocation
    };
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    this.initMap();
    this.initLocaiton();
  }

  initMap() {
    this.map = new Map(this.mapRef.current, {
      resizeEnable: true,
      zoom: 13,
    });
  }

  initLocaiton() {
    const { defaultLocation } = this.props;

    // console.log(defaultLocation);
    // if (defaultLocation.length === 0) {
    //   defaultLocation = [116.407041, 39.907123];
    // }

    this.map.loadGeoPlugin({}, (res) => {
      if (this.marker) {
        this.marker.setPosition(res.position);
      }
    })
      .then(() => {
        return this.map.locate();
      })
      .then((res) => {
        if (!this.marker) {
          this.marker = this.map.createMarker({
            position: res.position,
            draggable: true,
            offset: new window.AMap.Pixel(-10, -10)
          });

          this.marker.on('dragend', (result) => {
            const location = [result.lnglat.lng, result.lnglat.lat];
            this.setState({
              location
            });
            this.props.onLocationChange(location);
          });
        }
        const position = defaultLocation.length === 2
          ? new window.AMap.LngLat(...defaultLocation)
          : res.position;

        this.marker.setPosition(position);
        this.props.onLocationChange([position.lng, position.lat]);
        this.setState({
          location: [position.lng, position.lat]
        });
        setTimeout(() => {
          this.map.map.setCenter(position);
        }, 300);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    const { mapStyle } = this.props;
    const location = this.state.location;
    const style = {
      width: '100%',
      height: 300
    };

    return (
      <div className="location">
        <div className="map" ref={this.mapRef} style={{ ...style, ...mapStyle }}></div>
        <div className="location-desc" style={{ color: '#000', textAlign: 'center', marginTop: 10 }}>
          <span>经度：{location[0] || 116.407041}</span>&nbsp;&nbsp;
          <span>纬度：{location[1] || 39.907123}</span>
        </div>
      </div>
    );
  }
}
